export const apiKey = "AIzaSyCIZC4m-lS2-bcLINRQsm2XDtLzp-dTc4Y"
export const projectId = "bentodev-63dfc"
export const baseURL = 'forum/'
export const siteName = "Bento Forum"



// WEBPACK FOOTER //
// ./src/config.js